import React from 'react';
import styled from 'styled-components';

import { useOptionContext } from './option-context';

/** Discount badge (e.g. "20% OFF") for an option tile. Renders nothing when no discount or when strikethrough is hidden. */
export function TileDiscountLabel(): JSX.Element | null {
  const { discountLabel, originalPrice, listPriceEnabled, hideStrikethrough } = useOptionContext();

  if (!discountLabel || !originalPrice || hideStrikethrough) {
    return null;
  }

  return <Discount $listPriceEnabled={listPriceEnabled}>{discountLabel}</Discount>;
}

const Discount = styled.div<{ $listPriceEnabled?: boolean }>`
  color: ${({ $listPriceEnabled }) =>
    $listPriceEnabled ? 'var(--dcm-product-discount-color, #d34a4a)' : 'var(--dct--customized-colors-discountTag)'};
  font-weight: 600;
  white-space: nowrap;
`;
